import { grey } from '../colors';

/**
 *
 * Demos:
 *
 * - [Autocomplete](https://ui-packages.isbuildingluma.com/ui-core/react-autocomplete/)
 *
 * API:
 *
 * - [Autocomplete API](https://ui-packages.isbuildingluma.com/ui-core/api/autocomplete/)
 * - inherits [MuiAutocomplete API](https://mui.com/material-ui/api/autocomplete/)
 *
 * Styles:
 *
 * - [Proto](https://bhdgwebdesignsa.z22.web.core.windows.net/atoms.html)
 */
const MuiAutocomplete = {
  styleOverrides: {
    root: {
      '& .MuiOutlinedInput-root': {
        padding: '5px 9px',
        '& .MuiInputAdornment-positionStart': {
          paddingLeft: '6px'
        }
      }
    },
    paper: ({
      theme
    }) => ({
      backgroundColor: grey[200],
      borderRadius: `${theme.spacing()} !important`,
      border: `1px solid ${grey[300]}`,
      boxShadow: theme.shadows[10]
    }),
    listbox: ({
      theme
    }) => ({
      '& .Mui-focused': {
        backgroundColor: `${theme.palette.primary.light} !important`,
        color: `${theme.palette.primary.contrastText} !important`
      },
      '&::-webkit-scrollbar': {
        width: '8px'
      },
      '&::-webkit-scrollbar-track': {
        background: grey[200],
        borderRadius: theme.spacing(),
        marginBlock: theme.spacing(3)
      },
      '&::-webkit-scrollbar-thumb': {
        background: grey[500],
        borderRadius: theme.spacing(),
        width: 0
      },
      '& > li': {
        paddingInline: theme.spacing(1),
        borderRadius: theme.spacing()
      },
      paddingInline: theme.spacing(1)
    })
  }
};
export default MuiAutocomplete;